import useLenis from "@/hooks/useLenis";
import useSEO from "@/hooks/useSEO";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Story from "@/components/site/Story";
import Manifesto from "@/components/site/Manifesto";
import Products from "@/components/site/Products";
import Services from "@/components/site/Services";
import Partners from "@/components/site/Partners";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  useLenis();
  useSEO();
  return (
    <div className="grain relative bg-[#ffffff]" data-testid="home-page">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Story />
      <Manifesto />
      <Products />
      <Services />
      <Partners />
      <Contact />
      <Footer />
    </div>
  );
}
